module.exports = __webpack_public_path__ + "static/6305-woodrose-27-1f6dbc035456278a83aa806224e0a0ff.jpg";